import axios from "axios";
import { requestPayloadBodyFormate, responseDataFormate } from "../../../helpers/bycrypt";
import { catchHandler, dispatchError, dispatchLoading, dispatchToast, elseHandler } from "../../../helpers/dispatch";
import { API_URL } from "../../../helpers/utils";
import { AppDispatch } from "../../../store";
import { GetServiceParams } from "../../Types/state/masterdata";

const APK_API_URL = `${API_URL}/admin`;

export const CreateServicesAPI = (data: any, onClose: any) => (dispatch: AppDispatch) => {
  dispatchLoading(dispatch, "CreateService", true);
  const formatedData = requestPayloadBodyFormate(data);
  axios
    .post(`${APK_API_URL}/service`, formatedData, {
      withCredentials: true,
    })
    .then((response) => {
      let result = responseDataFormate(response.data);
      if (result?.success) {
        onClose();
        dispatchToast(dispatch, "success", result?.message);
        dispatchError(dispatch, "CreateService", undefined);
      } else elseHandler(dispatch, "CreateService", result);
      dispatchLoading(dispatch, "CreateService", false);
    })
    .catch((e) => {
      catchHandler(dispatch, "CreateService")(e);
    });
};

export const CreateServicesChangeOrderAPI =
  (data: any, onClose: any, setCurrentPage: any) => (dispatch: AppDispatch) => {
    dispatchLoading(dispatch, "CreateService", true);
    const formatedData = requestPayloadBodyFormate(data);
    axios
      .post(`${APK_API_URL}/service`, formatedData, {
        withCredentials: true,
      })
      .then((response) => {
        let result = responseDataFormate(response.data);
        if (result?.success) {
          dispatch({
            type: "ADD_CHANGE_ORDER_SERVICE",
            payload: result?.data,
          });

          onClose();
          dispatchToast(dispatch, "success", result?.message);
          dispatchError(dispatch, "CreateService", undefined);
        } else elseHandler(dispatch, "CreateService", result);
        dispatchLoading(dispatch, "CreateService", false);
      })
      .catch((e) => {
        catchHandler(dispatch, "CreateService")(e);
      });
  };

export const GetServicesAPI =
  (
    { page, limit, search, start_date, end_date, is_active, export_data, category, order, id, category_slug,}: GetServiceParams,
    setHasMore?: any
  ) =>
  async (dispatch: AppDispatch): Promise<void> => {
    dispatchLoading(dispatch, "getServices", true);
    // setIsLoading(true);
    let params: any = {};
    if (page) params["page"] = page;
    if (limit) params["limit"] = limit;
    if (search) params["search"] = search;
    if (start_date) params["start_date"] = start_date;
    if (end_date) params["end_date"] = end_date;
    if (is_active) params["is_active"] = is_active;
    if (export_data) params["export_data"] = export_data;
    if (category) params["category_id"] = category;
    if (order) params["order"] = order;
    if (id) params["id"] = id;
    if (category_slug) params["category_slug"] = category_slug;

    axios
      .get(`${APK_API_URL}/service/list`, {
        params: { ...params },
        withCredentials: true,
      })
      .then((response) => {
        let result = responseDataFormate(response.data);
        if (result?.success) {
          if (setHasMore) {
            setHasMore(result?.data?.data?.length == limit);
          }
          // setIsLoading(false);
          dispatch({
            type: "GET_SERVICES",
            payload: { ...result?.data, page: page },
          });
        } else elseHandler(dispatch, "getServices", result);
        dispatchLoading(dispatch, "getServices", false);
      })
      .catch((e) => {
        // setIsLoading(false);
        catchHandler(dispatch, "getServices")(e);
      })
      .finally(() => {
        dispatchError(dispatch, "getServices", undefined);
      });
  };

  export const GetForPublicServicesAPI =
  (
    { page, limit, search, start_date, end_date, is_active, export_data, category, order, id, category_slug,business}: GetServiceParams,
    setHasMore?: any
  ) =>
  async (dispatch: AppDispatch): Promise<void> => {
    dispatchLoading(dispatch, "getServices", true);
    // setIsLoading(true);
    let params: any = {};
    if (page) params["page"] = page;
    if (limit) params["limit"] = limit;
    if (search) params["search"] = search;
    if (start_date) params["start_date"] = start_date;
    if (end_date) params["end_date"] = end_date;
    if (is_active) params["is_active"] = is_active;
    if (export_data) params["export_data"] = export_data;
    if (category) params["category_id"] = category;
    if (order) params["order"] = order;
    if (id) params["id"] = id;
    if (business) params["business"] = business;
    if (category_slug) params["category_slug"] = category_slug;

    axios
      .get(`${APK_API_URL}/service/public/list`, {
        params: { ...params },
        withCredentials: true,
      })
      .then((response) => {
        let result = responseDataFormate(response.data);
        if (result?.success) {
          if (setHasMore) {
            setHasMore(result?.data?.data?.length == limit);
          }
          // setIsLoading(false);
          dispatch({
            type: "GET_SERVICES",
            payload: { ...result?.data, page: page },
          });
        } else elseHandler(dispatch, "getServices", result);
        dispatchLoading(dispatch, "getServices", false);
      })
      .catch((e) => {
        // setIsLoading(false);
        catchHandler(dispatch, "getServices")(e);
      })
      .finally(() => {
        dispatchError(dispatch, "getServices", undefined);
      });
  };

export const UpdateServicesAPI = (data: any, onClose: any) => async (dispatch: (action: any) => void) => {
  dispatchLoading(dispatch, "editService", true);
  const formatedData = requestPayloadBodyFormate(data);
  axios
    .put(`${APK_API_URL}/service`, formatedData, {
      withCredentials: true,
    })
    .then((response) => {
      let result = responseDataFormate(response.data);
      if (result?.success) {
        dispatch({
          type: "UPDATE_NAME_AND_CATEGORY",
          payload: result?.data,
        });
        // dispatch(GetServicesAPI(getServicePayload));
        onClose();
        dispatchToast(dispatch, "success", result?.message);
        dispatchError(dispatch, "editService", undefined);
      } else elseHandler(dispatch, "editService", result);
      dispatchLoading(dispatch, "editService", false);
    })
    .catch(catchHandler(dispatch, "editService"));
};

export const UpdateServicesDragAndDropAPI =
  (data: any, onClose: any, taskpayload: any) => async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "editService1", true);
    const formatedData = requestPayloadBodyFormate(data);
    axios
      .put(`${APK_API_URL}/service`, formatedData, {
        withCredentials: true,
      })
      .then((response) => {
        let result = responseDataFormate(response.data);
        if (result?.success) {
          dispatch({
            type: "UPDATE_SERVICE_DRAG_DROP",
            payload: { id: data?.id, task: taskpayload },
          });
          onClose();
          dispatchToast(dispatch, "success", result?.message);
          dispatchError(dispatch, "editService1", undefined);
        } else elseHandler(dispatch, "editService1", result);
        dispatchLoading(dispatch, "editService1", false);
      })
      .catch(catchHandler(dispatch, "editService1"));
  };

export const UpdateServicesTaskMaterialConsumablesAPI =
  (data: any, id: any) => async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "editService1", true);
    const formatedData = requestPayloadBodyFormate(data);
    axios
      .put(`${APK_API_URL}/service`, formatedData, {
        withCredentials: true,
      })
      .then((response) => {
        let result = responseDataFormate(response.data);
        if (result?.success) {
          // dispatch(GetServicesAPI(getServicePayload));
          dispatch({
            type: "UPDATE_SERVICE_DELETE_MAT_TAS_CON",
            payload: id,
          });

          dispatchToast(dispatch, "success", result?.message);
          dispatchError(dispatch, "editService1", undefined);
        } else elseHandler(dispatch, "editService1", result);
        dispatchLoading(dispatch, "editService1", false);
      })
      .catch(catchHandler(dispatch, "editService1"));
  };

export const DeleteServiceAPI =
  (data: { id: string }, onClose: any, getServicePayload?: GetServiceParams) => (dispatch: AppDispatch) => {
    const formatedData: any = requestPayloadBodyFormate(data);
    dispatchLoading(dispatch, "deleteService", true);
    axios
      .delete(`${APK_API_URL}/service`, {
        data: formatedData,
        withCredentials: true,
      })
      .then((response) => {
        let result = responseDataFormate(response.data);
        if (result?.success) {
          if (getServicePayload) {
            dispatch(GetServicesAPI(getServicePayload));
          } else {
            dispatch({
              type: "DELETE_SERVICE",
              payload: data?.id,
            });
          }
          onClose();
          dispatchToast(dispatch, "success", result?.message);
          dispatchError(dispatch, "deleteService", undefined);
        } else elseHandler(dispatch, "deleteService", result);
        dispatchLoading(dispatch, "deleteService", false);
      })
      .catch(catchHandler(dispatch, "deleteService"));
  };

export const PermanentDeleteServiceAPI =
  (data: { id: string }, onClose: any, getServicePayload: GetServiceParams) => (dispatch: AppDispatch) => {
    const formatedData: any = requestPayloadBodyFormate(data);
    dispatchLoading(dispatch, "deleteService", true);
    axios
      .delete(`${APK_API_URL}/service/permanent`, {
        data: formatedData,
        withCredentials: true,
      })
      .then((response) => {
        let result = responseDataFormate(response.data);
        if (result?.success) {
          dispatch(GetServicesAPI(getServicePayload));
          onClose();
          dispatchToast(dispatch, "success", result?.message);
          dispatchError(dispatch, "deleteMaterial", undefined);
        } else elseHandler(dispatch, "deleteService", result);
        dispatchLoading(dispatch, "deleteService", false);
      })
      .catch(catchHandler(dispatch, "deleteService"));
  };

export const RestoreServiceAPI =
  (data: any, onClose: any, getServicePayload: GetServiceParams) => async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "restoreService", true);
    const formatedData = requestPayloadBodyFormate(data);
    axios
      .put(`${APK_API_URL}/service/restore`, formatedData, {
        withCredentials: true,
      })
      .then((response) => {
        let result = responseDataFormate(response.data);
        if (result?.success) {
          dispatch(GetServicesAPI(getServicePayload));
          onClose();
          dispatchToast(dispatch, "success", result?.message);
          dispatchError(dispatch, "restoreService", undefined);
        } else elseHandler(dispatch, "restoreService", result);
        dispatchLoading(dispatch, "restoreService", false);
      })
      .catch(catchHandler(dispatch, "restoreService"));
  };

export const UploadServicesCsvAPI =
  (
    data: any,
    onClose: any,
    getServicePayload: GetServiceParams,
    setIsInvalidaDataModal?: any,
    setIsInvalidCsvData?: any,
    setIsAlreadyCsvData?: any,
    setIsInsertCsvData?: any
  ) =>
  (dispatch: AppDispatch) => {
    dispatchLoading(dispatch, "uploadServicesCsv", true);
    // const formatedData = requestPayloadBodyFormate(data);
    axios
      .post(`${APK_API_URL}/service/bulk`, data, {
        withCredentials: true,
      })
      .then((response) => {
        let result = responseDataFormate(response.data);
        if (result?.success) {
          setIsInvalidaDataModal(true);
          if (result?.data?.invalid_data?.length > 0) {
            setIsInvalidCsvData(result?.data?.invalid_data);
          }
          if (result?.data?.already_exist?.length > 0) {
            setIsAlreadyCsvData(result?.data?.already_exist);
          }
          if (result?.data?.insert_data?.length > 0) {
            setIsInsertCsvData(result?.data?.insert_data);
          }
          dispatch(GetServicesAPI(getServicePayload));
          // dispatchToast(dispatch, "success", result?.message);
          onClose();
          dispatchError(dispatch, "uploadServicesCsv", undefined);
        } else elseHandler(dispatch, "uploadServicesCsv", result);
        dispatchLoading(dispatch, "uploadServicesCsv", false);
      })
      // .catch(catchHandler(dispatch,"uploadServicesCsv"));
      .catch((e) => {
        catchHandler(dispatch, "uploadServicesCsv")(e);
      });
  };

export const DownloadServicesCsvFileAPI =
  ({ page, limit, is_active, export_data, filename }: any) =>
  async (dispatch: AppDispatch): Promise<void> => {
    dispatchLoading(dispatch, "downloadServicesFile", true);
    // setIsLoading(true);
    let params: any = {};
    if (page) params["page"] = page;
    if (limit) params["limit"] = limit;
    if (is_active) params["is_active"] = is_active;
    if (export_data) params["export_data"] = export_data;
    axios
      .get(`${APK_API_URL}/service/list`, {
        params: { ...params },
        withCredentials: true,
      })
      .then((response) => {
        const result = response?.data;
        if (result) {
          dispatchLoading(dispatch, "downloadServicesFile", false);
          const blob = new Blob([result], { type: "text/csv" });
          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.download = `${filename}.csv`;
          link.click();
          dispatchError(dispatch, "downloadServicesFile", undefined);
        } else elseHandler(dispatch, "downloadServicesFile", result);
        dispatchLoading(dispatch, "downloadServicesFile", false);
      })
      .catch((e) => {
        // setIsLoading(false);
        catchHandler(dispatch, "downloadServicesFile")(e);
      });
  };

export const AddTaskServicesAPI = (data: any, onClose: any) => (dispatch: AppDispatch) => {
  dispatchLoading(dispatch, "addTaskService", true);
  const formatedData = requestPayloadBodyFormate(data);
  axios
    .post(`${APK_API_URL}/service/task`, formatedData, {
      withCredentials: true,
    })
    .then((response) => {
      let result = responseDataFormate(response.data);
      if (result?.success) {
        dispatch({
          type: "ADD_TASK_IN_SERVICE",
          payload: result?.data,
        });
        onClose();
        dispatchToast(dispatch, "success", result?.message);
        dispatchError(dispatch, "addTaskService", undefined);
      } else elseHandler(dispatch, "addTaskService", result);
      dispatchLoading(dispatch, "addTaskService", false);
    })
    .catch((e) => {
      catchHandler(dispatch, "addTaskService")(e);
    });
};

export const AddMaterialServicesAPI = (data: any, onClose: any) => (dispatch: AppDispatch) => {
  dispatchLoading(dispatch, "addMaterialService", true);
  const formatedData = requestPayloadBodyFormate(data);
  axios
    .post(`${APK_API_URL}/service/material`, formatedData, {
      withCredentials: true,
    })
    .then((response) => {
      let result = responseDataFormate(response.data);
      if (result?.success) {
        dispatch({
          type: "ADD_MATERIAL_IN_SERVICE",
          payload: result?.data,
        });
        onClose();
        dispatchToast(dispatch, "success", result?.message);
        dispatchError(dispatch, "addMaterialService", undefined);
      } else elseHandler(dispatch, "addMaterialService", result);
      dispatchLoading(dispatch, "addMaterialService", false);
    })
    .catch((e) => {
      catchHandler(dispatch, "addMaterialService")(e);
    });
};

export const AddConsumableServicesAPI = (data: any, onClose: any) => (dispatch: AppDispatch) => {
  dispatchLoading(dispatch, "addConsumableService", true);
  const formatedData = requestPayloadBodyFormate(data);
  axios
    .post(`${APK_API_URL}/service/consumable`, formatedData, {
      withCredentials: true,
    })
    .then((response) => {
      let result = responseDataFormate(response.data);
      if (result?.success) {
        dispatch({
          type: "ADD_CONSUMABLE_IN_SERVICE",
          payload: result?.data,
        });
        onClose();
        dispatchToast(dispatch, "success", result?.message);
        dispatchError(dispatch, "addConsumableService", undefined);
      } else elseHandler(dispatch, "addConsumableService", result);
      dispatchLoading(dispatch, "addConsumableService", false);
    })
    .catch((e) => {
      catchHandler(dispatch, "addConsumableService")(e);
    });
};

export const DeleteServiceTaskAPI = (data: any) => (dispatch: AppDispatch) => {
  const formatedData: any = requestPayloadBodyFormate(data);
  dispatchLoading(dispatch, "deleteServiceTask", true);
  axios
    .delete(`${APK_API_URL}/service/task`, {
      data: formatedData,
      withCredentials: true,
    })
    .then((response) => {
      let result = responseDataFormate(response.data);
      if (result?.success) {
        dispatch({
          type: "DELETE_TASK_SERVICE",
          payload: { task_id: data?.task_id, service_id: data?.service_id },
        });
        dispatchToast(dispatch, "success", result?.message);
        dispatchError(dispatch, "deleteServiceTask", undefined);
      } else elseHandler(dispatch, "deleteServiceTask", result);
      dispatchLoading(dispatch, "deleteServiceTask", false);
    })
    .catch(catchHandler(dispatch, "deleteServiceTask"));
};

export const DeleteServiceMaterialAPI = (data: any) => (dispatch: AppDispatch) => {
  const formatedData: any = requestPayloadBodyFormate(data);
  dispatchLoading(dispatch, "deleteServiceMaterial", true);
  axios
    .delete(`${APK_API_URL}/service/material`, {
      data: formatedData,
      withCredentials: true,
    })
    .then((response) => {
      let result = responseDataFormate(response.data);
      if (result?.success) {
        dispatch({
          type: "DELETE_MATERIAL_SERVICE",
          payload: { material_id: data?.material_id, service_id: data?.service_id },
        });
        dispatchToast(dispatch, "success", result?.message);
        dispatchError(dispatch, "deleteServiceMaterial", undefined);
      } else elseHandler(dispatch, "deleteServiceMaterial", result);
      dispatchLoading(dispatch, "deleteServiceMaterial", false);
    })
    .catch(catchHandler(dispatch, "deleteServiceMaterial"));
};

export const DeleteServiceConsumableAPI = (data: any) => (dispatch: AppDispatch) => {
  const formatedData: any = requestPayloadBodyFormate(data);
  dispatchLoading(dispatch, "deleteServiceConsumable", true);
  axios
    .delete(`${APK_API_URL}/service/consumable`, {
      data: formatedData,
      withCredentials: true,
    })
    .then((response) => {
      let result = responseDataFormate(response.data);
      if (result?.success) {
        dispatch({
          type: "DELETE_CONSUMABLE_SERVICE",
          payload: { consumable_id: data?.consumable_id, service_id: data?.service_id },
        });
        dispatchToast(dispatch, "success", result?.message);
        dispatchError(dispatch, "deleteServiceConsumable", undefined);
      } else elseHandler(dispatch, "deleteServiceConsumable", result);
      dispatchLoading(dispatch, "deleteServiceConsumable", false);
    })
    .catch(catchHandler(dispatch, "deleteServiceConsumable"));
};

export const DragAndDropTaskAPI = (data: any, payloadData: any) => async (dispatch: (action: any) => void) => {
  dispatchLoading(dispatch, "taskReorder", true);
  const formatedData = requestPayloadBodyFormate(data);
  axios
    .put(`${APK_API_URL}/service/task/order`, formatedData, {
      withCredentials: true,
    })
    .then((response) => {
      let result = responseDataFormate(response.data);
      if (result?.success) {
        // onClose();
        // dispatch({
        //   type: "SET_TASKS_ORDER",
        //   payload: { id: data?.service_id, data: payloadData },
        // });
        dispatchToast(dispatch, "success", result?.message);
        dispatchError(dispatch, "taskReorder", undefined);
      } else elseHandler(dispatch, "taskReorder", result);
      dispatchLoading(dispatch, "taskReorder", false);
    })
    .catch(catchHandler(dispatch, "taskReorder"));
};
